class RMAInvoice {

	/**
	 * @type {string}
	 */
	storageKey = 'rma-invoice';

	/**
	 * @type {import('../types').RMAInvoiceState}
	 */
	state;

	constructor () {
		this.state = this.get();
	}

	/**
	 * @returns {import('../types').RMAInvoiceState}
	 */
	get () {
		return JSON.parse(sessionStorage.getItem(this.storageKey));
	}

	/**
	 * @param {import('../types').RMAInvoiceState} state
	 */
	set (state = {}) {
		sessionStorage.setItem(this.storageKey, JSON.stringify(state));

		this.state = state;

		return state;
	}
};

export const rmaInvoiceStore = new RMAInvoice();
